import Component from '../abstracts/Component';
import { html } from 'htm/preact';
import {doAjax} from '../utils/ajaxUtil';
import _ from "lodash";
import Cookies from 'js-cookie';
import algoliasearch from 'algoliasearch';
import { createQuerySuggestionsPlugin } from '@algolia/autocomplete-plugin-query-suggestions';
import { getAlgoliaResults } from '@algolia/autocomplete-preset-algolia';
import { autocomplete } from '@algolia/autocomplete-js';
import '@algolia/autocomplete-theme-classic';


export default class SearchLayerComponent extends Component {

  get SELECTORS() {
    return {
      closeBtn: '[data-search-close]',
      closeSearchlayer: '[data-close-searchlayer]',
      clearBtn: '#search_field_box .icon-close',
      searchInput: '#search_field',
      searchAutocomplete: '.aa-Input',
      searchEditorial: '.search-editorial',
      searchSuggestions: '[data-search-suggestions]',
      searchSuggestionsContainer: '[data-search-suggestions-container]',
      searchSuggestionsWrapper: '.l-s__suggestions',
      searchForm: '[data-search-form]',
      searchJsSubmit: '.js-search-submit',
      searchJsSubmitInput: '#search_field_box input',
      // page: '#page-wrapper',
      page: '#l-search-box',
      searchWrapper: '.l-s__wrapper',
      topSearchesWrapper: '.search-bar__prefill',
      navigationCards: '.l-s__cards',
      searchBarCategory: '.search-bar__category-container',
      searchBarNoResults: 'search-bar__no-results',
      searchOverlay: '.l-search__overlay'
    };
  }

  get CSS_CLASSNAMES() {
    return {
      open: 'search-open',
      hidden: 'hidden'
    };
  }

  get CONST() {
    return {
      baseUrl: 'https://query-suggestions.eu.algolia.com',
      baseUri: '/1/configs',
      indexName: '/'
    }
  }

  constructor(compEl) {
    super(compEl);
    this.closeBtn = this.$component.querySelector(this.SELECTORS.closeBtn);
    this.closeSearchlayer = this.$component.querySelector(this.SELECTORS.closeSearchlayer);
    this.clearBtn = this.$component.querySelector(this.SELECTORS.clearBtn);
    this.searchInput = this.$component.querySelector(this.SELECTORS.searchInput);
    // this.searchAutocomplete = this.$component.querySelector(this.SELECTORS.searchAutocomplete);
    this.searchEditorial = this.$component.querySelector(this.SELECTORS.searchEditorial);
    this.searchSuggestions = this.$component.querySelector(this.SELECTORS.searchSuggestions);
    this.searchSuggestionsContainer = this.$component.querySelector(this.SELECTORS.searchSuggestionsContainer);
    this.searchSuggestionsWrapper = this.$component.querySelector(this.SELECTORS.searchSuggestionsWrapper);
    this.searchForm = this.$component.querySelector(this.SELECTORS.searchForm);
    this.searchJsSubmit = this.$component.querySelector(this.SELECTORS.searchJsSubmit);
    this.searchJsSubmitInput = this.$component.querySelector(this.SELECTORS.searchJsSubmitInput);
    this.page = document.querySelector(this.SELECTORS.page);
    this.searchWrapper = this.page.querySelector(this.SELECTORS.searchWrapper);
    //
    this.searchFormUrl = this.searchForm.getAttribute('action');
    this.searchFormUrlJs = this.searchForm.getAttribute('data-js-search-url');
    this.input = this.$component.querySelector('input');
    this.scrollY = 0;
    this.searchIndex = this.$component.getAttribute('data-search-index');
    this.appID = this.$component.getAttribute('data-search-appID');
    this.apiKey = this.$component.getAttribute('data-search-apiKey');
    this.analyticsApiKey = this.$component.getAttribute('data-search-analyticsApiKey');
    this.topSearchesWrapper = document.querySelector(this.SELECTORS.topSearchesWrapper);
    this.navigationCards = document.querySelector(this.SELECTORS.navigationCards);
    this.searchBarNoResults = document.querySelector(this.SELECTORS.searchBarNoResults);
    this.isSaleMode = this.$component.getAttribute('data-search-sale');
    this.salesLabel = this.$component.getAttribute('data-sales-label');
    this.imageProductLabel = this.$component.getAttribute('data-image-product-label');
  }

  debouncePromise(fn, time) {
    let timerId = undefined;

    return function debounced(...args) {
      if (timerId) clearTimeout(timerId);

      return new Promise((resolve) => {
        timerId = setTimeout(() => resolve(fn(...args)), time);
      });
    };
  }

  openLayer() {
    console.log('opening layer...');
    this.$component.classList.add(this.CSS_CLASSNAMES.open);
    this.$emit(this.$customEvents.SEARCH_LAYER_EVENTS.opened);
    this.bindAutocompleteEvents();
    if (this.searchAutocomplete) {
      this.searchAutocomplete.focus();
    } else if (this.searchInput){
      this.searchInput.focus();
    }
  }

  closeLayer() {
    if (this.$component.classList.contains(this.CSS_CLASSNAMES.open)) {
      this.$component.classList.remove(this.CSS_CLASSNAMES.open);
      document.body.style.overflowY = 'auto';
      this.$emit(this.$customEvents.SEARCH_LAYER_EVENTS.closed);
      if (this.searchAutocomplete) {
        this.searchAutocomplete.blur();
      } else if (this.searchInput){
        this.searchInput.blur();
      }
    }
  }

  listenClose() {
    if (!this.closeBtn) {
      return;
    }
    this.closeBtn.addEventListener('click', () => {
      this.$emit(this.$customEvents.SEARCH_LAYER_EVENTS.close);
    });
    this.closeSearchlayer?.addEventListener('click', () => {
      this.$emit(this.$customEvents.SEARCH_LAYER_EVENTS.close);
    });
    this.page.addEventListener('click', () => {
      this.$emit(this.$customEvents.SEARCH_LAYER_EVENTS.close);
    });
    this.searchWrapper.addEventListener('click', (e) => {
      e.stopPropagation();
    });
    this.searchWrapper.addEventListener('mouseleave', (e) => {
      console.log({e});
      if (e.relatedTarget === this.page) {
        this.closeLayer();
        this.$emit(this.$customEvents.SEARCH_LAYER_EVENTS.close);
      }
    });
  }

  getSuggestion(index, suggestionsIndex, search = false) {
    let ctx = this;
    // X-Algolia-Application-Id: the application ID.
    // X-Algolia-API-Key: the admin API key for given application ID.
    const appId = this.appID;
    const apiKey = this.apiKey;
    const searchClient = algoliasearch(appId, apiKey);

    const debounced = this.debouncePromise((items) => Promise.resolve(items), 300);

    const querySuggestionsPlugin = createQuerySuggestionsPlugin({
      searchClient,
      indexName: suggestionsIndex,
      getSearchParams({state}) {
        return {hitsPerPage: 6};
      },
      transformSource({source}) {
        return {
          ...source,
          templates: {
            header() {
              return ctx.$component.dataset.searchLabelSuggestions;
            },
            item(params) {
              // console.log({params})
              const {item, html} = params;
              return html`<a class="" href="/search?q=${item.query}">
                ${item.query}
              </a>`;
            },
            noResults() {
              return ctx.$component.dataset.searchLabelNoresults;
            }
          }
        }
      }
    })
    
    const urlParams = new URLSearchParams(window.location.search);
    const initialSearchTerm = urlParams.get('text') || urlParams.get('q') || '';
    
    autocomplete({
      debug: true,
      container: '#l-s__search',
      panelContainer: '#l-s__suggestions',
      placeholder: ctx.$component.dataset.searchPlaceholder ,
      detachedMediaQuery: 'none',
      plugins: [querySuggestionsPlugin],
      initialState: {
        query: initialSearchTerm ? decodeURIComponent(initialSearchTerm) : ''
      },
      getSources({ query, setContext }) {
        return debounced([
          {
            sourceId: 'querySuggestions',
            getItems() {
              // if (query.length > 3) {
                return getAlgoliaResults({
                  searchClient,
                  queries: [
                    {
                      indexName: index,
                      query,
                    },
                  ],
                  transformResponse({results, hits}) {
                    setContext({
                      nbHits: results[0].nbHits,
                      hits: hits.length
                    });
                    return hits;
                  }
                });
              // }
            },
            getItemUrl({ item }) {
              return item.url;
            },
            getItemInputValue({ item }) {
              return item.query;
            },
            templates: {
              header() {
                return ctx.$component.dataset.searchLabelHits;
              },
              item({ item }) {
                let originalPrice;
                let currency = item.currency;
                let discounted = true;
                const image = item.image_index;
                const title = item.title;
                const link = item.link;
                let insale_class = false;
                let sp_class = false;
                // return html`<a href="${item.link}">${item.title} <span class="color"> ${item.color} </span></a>`;
                if ((ctx.isSaleMode || item.specialPrice) && item.sale_price !== '' && item.inSale && item.salesPrice > 0) {
                  insale_class = true;
                  if (item.specialPrice) {
                    originalPrice = item.breakdownPrice;
                  } else {
                    originalPrice = item.price;
                  }
                } else if (item.specialPrice) {
                  sp_class = true;
                  originalPrice = item.price;
                } else {
                  discounted = false;
                }
                return html`
                  <a href="${link}" class="l-s__suggestions__content__item" aria-label="${ctx.imageProductLabel.replace('{0}', title)}">
                    <img src="${image}" class="l-s__suggestions__content__item__image" alt="${ctx.imageProductLabel.replace('{0}', title)}"/>
                    <div class="l-s__suggestions__content__item__details">
                      <span class="l-s__suggestions__content__item__details__insale">${insale_class ? `${ctx.salesLabel} -${item.salePercentageValue}%` : ''}</span>
                      <span class="l-s__suggestions__content__item__details__sp">${sp_class ? 'Special Price' : ''}</span>
                      <span class="l-s__suggestions__content__item__details__title">${title}</span>
                      <div class="l-s__suggestions__content__item__details__price">
                        <span class="l-s__suggestions__content__item__details__price__original  ${currency}">${discounted ? `${originalPrice}` : ''}</span>
                        <span class="l-s__suggestions__content__item__details__price__discounted${insale_class ? '__insale' : item.specialPrice ? '__sp' : ''} ${currency}"> ${item.sale_price}</span>
                      </div>
                    </div>
                  </a>
                `;
              },
              footer({html, state}) {
                // const hits = state.context.nbHits;
                return html`<a href="${ctx.searchFormUrlJs}?text=${state.query}">${ctx.$component.dataset.searchLabelResults}</a>`;
              },
              noResults() {
                return ctx.$component.dataset.searchLabelNoresults;
              }
            },
          },
        ]);
      },
      onStateChange(state) {
        if (state.state.query && state.state.query !== '') {
          ctx.searchSuggestionsWrapper.classList.remove(ctx.CSS_CLASSNAMES.hidden);
          // ctx.searchEditorial.classList.add(ctx.CSS_CLASSNAMES.hidden);
          ctx.topSearchesWrapper.classList.add(ctx.CSS_CLASSNAMES.hidden);
          ctx.navigationCards && ctx.navigationCards.classList.add(ctx.CSS_CLASSNAMES.hidden);
        } else {
          ctx.searchSuggestionsWrapper.classList.add(ctx.CSS_CLASSNAMES.hidden);
          // ctx.searchEditorial.classList.remove(ctx.CSS_CLASSNAMES.hidden);
          ctx.topSearchesWrapper.classList.remove(ctx.CSS_CLASSNAMES.hidden);
          ctx.navigationCards && ctx.navigationCards.classList.remove(ctx.CSS_CLASSNAMES.hidden);
        }
      }
    });

  }

  getTopSearches() {
    let ctx = this;
    let index = ctx.$component.dataset.searchIndex;
    let url = 'https://analytics.de.algolia.com/2/searches?index=' + index;
    return doAjax({
      headers: {
        'X-Algolia-API-Key': this.analyticsApiKey,
        'X-Algolia-Application-Id': this.appID,
      },
      url: url,
      dataType: "html",
      type: 'GET',
      cache: true,
      success: function (resp) {
        ctx.log('Call Successful');
        let parsedResp = JSON.parse(resp);
        let searchContainer = document.querySelector('[data-searches-container]');
        parsedResp.searches = parsedResp.searches.filter((s) => (s.search != '') && s);
        if (parsedResp.searches.length > 5) {
          parsedResp.searches = parsedResp.searches.filter((s, index) => (index < 6) && s);
        }
        // console.log({parsedResp})
        try {
          for (let i = 0; i < parsedResp.searches.length; i++) {
            let searchEl = parsedResp.searches[i];
            // exclude empty searches
            if (searchEl.nbHits < 1) {
              continue;
            }
            // populate searches
            if (searchContainer.querySelectorAll('.search-bar__category').length < 6) {
              const el = ctx.topSearchTemplate(searchEl.search);
              el && searchContainer.appendChild(el);
              // hide no results section
              ctx.searchBarNoResults && ctx.searchBarNoResults.classList.add(this.CSS_CLASSNAMES.hidden);
            }
          }
          ctx.topSearchesWrapper.classList.remove('hidden');
        } catch (e) {
          console.warn("Algolia Top Searches response has failed.", e);
        }
      },
      error: function (xhr) {
        console.log(xhr);
      }
    });
  }

  topSearchTemplate(search) {
    let searchEl = document.createElement("div");
    searchEl.classList.add(this.SELECTORS.searchBarCategory, "search-bar__subtitle");
    let searchLink = document.createElement("a");
    searchLink.href = this.searchFormUrlJs + '?text=' + encodeURIComponent(search);
    searchLink.innerHTML = search;
    searchEl.appendChild(searchLink);
    return searchEl;
  }

  // bind keyup
  bindSearch() {
    let ctx = this;
    let timer;
    let index = ctx.$component.dataset.searchIndex;
    const suggestionsIndex = ctx.$component.dataset.searchIndexSuggestions;
    //ctx.$component.dataset.searchEnv + '_' + ctx.$component.dataset.searchBrand.toLowerCase() + '_' + ctx.$component.dataset.searchCountry + '_' + ctx.$component.dataset.searchLanguage;
    //
    ctx.getSuggestion(index, suggestionsIndex);
  }

  jsSearchPage() {
    // get autocomplete value
    let autocompleteInput = this.$component.querySelector(this.SELECTORS.searchJsSubmitInput);
    // build url
    let url = this.searchFormUrlJs+'?text='+autocompleteInput.value;
    // go to url
    window.location.href = url;
  }

  bindAutocompleteEvents() {
    this.searchAutocomplete = this.$component.querySelector(this.SELECTORS.searchAutocomplete);
    this.searchOverlay = document.querySelector(this.SELECTORS.searchOverlay);

    if (this.searchAutocomplete) {
      this.searchAutocomplete.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          // build url
          let url = this.searchFormUrlJs + '?text=' + this.searchAutocomplete.value;
          // go to url
          window.location.href = url;
        }
      });
    }

    if (this.searchOverlay) {
      this.searchOverlay.addEventListener('click', (e) => {
        this.$emit(this.$customEvents.SEARCH_LAYER_EVENTS.close);
      });
    }
  }

  bindEvents() {
    let ctx = this;
    this.$on(this.$customEvents.SEARCH_LAYER_EVENTS.open, () => {
      this.openLayer();
    });
    this.$on(this.$customEvents.SEARCH_LAYER_EVENTS.close, () => {
      this.closeLayer();
    });

    this.clearBtn && this.clearBtn.addEventListener('click', () => {
      if (ctx.searchInput) ctx.searchInput.value = '';
    });

    // if suggestions are enabled, i want to keep the standard search working
    if (this.searchJsSubmit != null) {
      this.searchJsSubmit.addEventListener('click', (e) => {
        e.preventDefault();
        // go
        this.jsSearchPage();
      });
      // enables Enter key to submit search
      this.searchForm.addEventListener('keypress', (e) => {
        if (e.keyCode === 13) {
          e.preventDefault();
          // go
          ctx.jsSearchPage();
        }
      });
    }
  }

  render() {
    super.render();
    this.listenClose();
    this.bindEvents();
    // if is enabled
    if (this.$component.attributes['data-algolia-enabled'].nodeValue == 'true') {
      this.getTopSearches();
      if (this.$component.attributes['data-search-suggestions'].nodeValue == 'true') {
        this.bindSearch();
      }
    }
  }
}
